import { useMemo } from "react";
import { useSelector } from "react-redux";

import { CONSTANTS } from "@/constants";

const ALLOWED_VIEWS = CONSTANTS("LIST_LIMITS").map((option) => option.value);
const FALLBACK_LIMIT = CONSTANTS("DEFAULT_LIST_LIMIT");

const normalize = (value) => {
    const num = Number(value);
    if (!Number.isFinite(num)) return null;
    return ALLOWED_VIEWS.includes(num) ? num : null;
};

const readViewInfoLimit = (viewInfoKey) => {
    try {
        const raw = localStorage.getItem(viewInfoKey);
        if (!raw) return null;
        return normalize(JSON.parse(raw)?.limit);
    } catch {
        return null;
    }
};

/**
 * 목록 페이지네이션 기본 Views(limit) 값 계산 훅
 *
 * 우선순위:
 *   1) 도메인별 viewInfo.limit (localStorage)
 *   2) settings.project.General.consoleDefaultListViews.value (Redux)
 *   3) 20
 *
 * @param {object} [options]
 * @param {string} [options.viewInfoKey] viewStorage 에서 사용하는 key (예: "videosViewInfo")
 * @returns {number} 기본 limit (화이트리스트 외 값은 20 으로 fallback)
 */
const useDefaultListLimit = ({ viewInfoKey } = {}) => {
    const settingsLimit = useSelector(({ settings }) => settings?.project?.General?.consoleDefaultListViews?.value);

    return useMemo(() => {
        if (viewInfoKey) {
            const fromViewInfo = readViewInfoLimit(viewInfoKey);
            if (fromViewInfo) return fromViewInfo;
        }

        const fromSettings = normalize(settingsLimit);
        if (fromSettings) return fromSettings;

        return FALLBACK_LIMIT;
    }, [viewInfoKey, settingsLimit]);
};

export default useDefaultListLimit;
